export class OwnerWelcomeLetterParameterDto {
    sendByEmail: boolean;
    sendByMail: boolean;
    communityId: number;
    customerId: string;
    clearCache: boolean;

    getQueryString(): string {
        let url = `?clearCache=${this.clearCache}`;

        if (this.communityId) {
            url = `${url}&communityId=${this.communityId}`;
        }

        if (this.customerId) {
            url = `${url}&customerId=${this.customerId}`;
        }
        return url;
    }
}
